module.exports = __webpack_public_path__ + "empty.62072a28.png";